import Button from "@components/UI/Button.tsx";
import { useState } from "react";
import TariffModal from "@components/TariffModal.jsx";
import InvestorModal from "@components/InvestorModal.jsx";
import { useAuth } from "@/utils/auth-context.tsx";

const Orders = () => {
  const orders = [
    {
      name: "Марина",
      order: "дизайнер карточек на Амазон",
      budget: "80$",
    },

    {
      name: "Айсултан",
      order: "разработчик сайта Shopify",
      budget: "500$",
    },

    {
      name: "Марк",
      order: "разработчик сайта Shopify",
      budget: "440$",
    },

    {
      name: "Наиль",
      order: "дизайнер карточек на Амазон",
      budget: "80$",
    },

    {
      name: "Александра",
      order: "дизайнер карточек на Амазон",
      budget: "90$",
    },

    {
      name: "Айбек",
      order: "дизайнер карточек на Амазон",
      budget: "80$",
    },
  ];

  const [openTariffModal, setOpenTariffModal] = useState(false);
  const { isVerified } = useAuth();
  const [clickedOrder, setClickedOrder] = useState("");

  return (
    <div className="layout">
      <div className="orders">
        {orders.map((order, index) => (
          <div className="orders-item" key={index}>
            <p className="orders-item__name">{order.name}</p>
            <p>
              В поисках: <span>{order.order}</span>
            </p>
            <p>
              Бюджет: <span>{order.budget}</span>
            </p>
            <div className="orders-item__button">
              <Button
                title="Откликнуться"
                color="pink"
                onClick={() => {
                  setOpenTariffModal(true);
                  setClickedOrder(order.name);
                }}
              />
            </div>
          </div>
        ))}

        {openTariffModal &&
          (!isVerified ? (
            <InvestorModal
              text={`Доступ временно закрыт`}
              closeModal={() => setOpenTariffModal(false)}
            />
          ) : (
            <InvestorModal
              text={`${clickedOrder} получил/a ваш отклик. Ожидайте`}
              closeModal={() => setOpenTariffModal(false)}
            />
          ))}
      </div>
    </div>
  );
};

export default Orders;
